import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 14\" id=\"icon-report\">\r\n<path d=\"M16,14H0L8,0L16,14z M1.7,13h12.6L8,2L1.7,13z M7.6,9.8l-0.4-3V5h1.6v1.8l-0.4,3H7.6z M7.2,12v-1.6h1.6V12H7.2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/report.svg
// module id = 308
// module chunks = 0 1